module.exports = __webpack_public_path__ + "static/media/text.43214024.png";